import { gql } from '@apollo/client';

const getAllFaqs = (category) => ({
  query: gql`
    query getAllFaqs($category: String) {
      faqs(first: 100, where: {categoryName: $category}) {
        nodes {
          title
          content
        }
      }
    }
  `,
  variables: {
    category,
  },
});

export default getAllFaqs;
